import "./polyfill/number-is-nan";

import "bootstrap-sass";
import "jquery-match-height";

import "./modules/webfont";
import "./modules/view-more";
import "./modules/page-top";
// import "./modules/jqueryvalidation";
import "./modules/menu-trigger";
// import "./modules/bs.tab";
import "./modules/js-header";
// import "./modules/js-footer";
import "./modules/waypoints";
// import "./modules/dropdown-hover";
import "./modules/swiper-fv";
import "./modules/stickysidebar";
import "./modules/aos";
import "./modules/jquery-match-height";
import "./modules/text-fluffy";
import "./modules/smoothScroll";
import "./modules/hide-component";
import "./modules/title-animation-page-load";
import "./modules/animation";
// import "./modules/grBackToTop";
// import ScrollMagic from "scrollmagic";
